import { Typography } from '@mui/material';
import React from 'react';

type KpiWorkunitGridData = {
  price: string;
};

const PriceCell = React.memo((row: KpiWorkunitGridData) => (
  <Typography variant="body2" noWrap>
    {row?.price ?? '0'}
  </Typography>
));

export default PriceCell;
